import { Box } from '@components/Box';
import { TextPairing } from '@components/TextPairing';
import { themeMediaQuery, themeSpace } from '@utils/styledTheme.util';
import styled from 'styled-components';

const PAGE_MAX_WIDTH = '1200px';

export const StyledSection = styled(Box)`
  padding: 0px ${themeSpace(7)};
  display: grid;
  gap: ${themeSpace(9)};
  ${themeMediaQuery('md')} {
    padding: 82px ${themeSpace(12)};
    grid-template-columns: 1fr 2fr;
  }
  ${themeMediaQuery('lg')} {
    max-width: ${PAGE_MAX_WIDTH};
    padding: 82px 0;
  }
`;

export const StyledTextPairing = styled(TextPairing)`
  ${themeMediaQuery('md')} {
    max-width: 629px;
  }
`;
